import { useEffect, useState } from 'react';
import type { PageExperienceFragment } from '@/features/experiences/fragments/PageExperience.generated';

export const useExperience = (experience?: PageExperienceFragment | null) => {
  const [statefulExperience, setStatefulExperience] =
    useState<PageExperienceFragment | null>(experience ?? null);

  useEffect(() => {
    setStatefulExperience(experience ?? null);
  }, [experience]);

  return {
    experience: statefulExperience,
    setExperience: setStatefulExperience,
  };
};
